import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  divisionPersonalLength: 0,
  divisionPersonal: [],
  divisionPersonalError: "",
  formError: "",
}

export default function divisionPersonalReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_PERSONAL_DIVISION:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_PERSONAL_DIVISION:
      return {...state, saveLoader: action.payload}
    case actions.GET_PERSONAL_DIVISION:
      return {...state, divisionPersonal: action.payload.divisionPersonal, divisionPersonalLength: action.payload.divisionPersonalLength}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.PERSONAL_DIVISION_FAIL:
      return { ...state, divisionPersonalError: action.payload };
    default:
      return {...state};
  }
}